import ButtonCircle from '@/components/ButtonCircle';
import type { BannerBlockProps } from './BannerBlock.types';

const BannerBlock: React.FC<BannerBlockProps> = ({
  title,
  showTitle,
  content,
  appStoreLink,
  googlePlayLink,
  linkText,
  linkExternal,
  linkHref,
}) => {
  const hasCta = linkText && linkText.length > 0;

  const hasAppLinks = appStoreLink || googlePlayLink;

  return (
    <div className="banner-block">
      {showTitle && title && <h2 className="banner-block__heading">{title}</h2>}
      {content && (
        <div
          className="banner-block__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}

      {hasAppLinks && (
        <div className="banner-block__app-links">
          {appStoreLink && (
            <a
              className="banner-block__app-link"
              href={appStoreLink}
              target="_blank"
              data-app-link="iOS"
              rel="noreferrer"
            >
              <img
                className="banner-block__app-image"
                src="/_resources/app/client/img/app-store.svg"
                alt="Download on the App Store"
              />
            </a>
          )}
          {googlePlayLink && (
            <a
              className="banner-block__app-link"
              href={googlePlayLink}
              target="_blank"
              data-app-link="Android"
              rel="noreferrer"
            >
              <img
                className="banner-block__app-image"
                src="/_resources/app/client/img/google-play.svg"
                alt="Get it on Google Play"
              />
            </a>
          )}
        </div>
      )}

      {hasCta && (
        <a
          className={`banner-block__cta button button--primary ${linkExternal ? 'button--external' : ''}`}
          href={linkHref}
          target={linkExternal ? '_blank' : ''}
          rel="noreferrer"
        >
          {linkText}
          <ButtonCircle arrowHeight={13} arrowWidth={17} />
        </a>
      )}
    </div>
  );
};

export default BannerBlock;
